import Box from '@mui/material/Box';
import { Field, RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import { Container } from './IFrameBlock.styles';

export type IFrameBlockProps = ComponentProps & {
  fields?: {
    content?: Field<string>;
  };
};

const IFrameBlock = (props: IFrameBlockProps): JSX.Element => {
  if (!props?.fields) return <></>;
  const { fields } = props;

  const content = fields?.content;

  return (
    <>
      <Container id="iframe-content-block" className="ui-iframe-content-block">
        <Box>
          {content?.value && (
            <RichText
              field={content}
              cssClassName={'iframe-content'}
              inheritLinkColor={false}
            ></RichText>
          )}
        </Box>
      </Container>
    </>
  );
};

export default IFrameBlock;
